import * as React from 'react';
import {useDispatch} from 'react-redux';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import type {FilterObject} from 'nutshell-core/types';

import {PageControlBar} from 'shells/control-bar/page-control-bar';
import {HelpButton} from 'shells/help/help-button';
// @ts-expect-error - imported from .js/.jsx file
import {CogIcon} from 'shells/icon/svg/cog-icon';
import {CompanyContactIcon} from 'shells/icon/svg/company-contact-icon';
import {TabbedContent} from 'shells/layout/tabbed-content';

import {PageContainer, PageTitleBar} from '../../layout';
import {OpenableModals, useOpenableModal} from '../../openable-modals';
import type {ReportURLParams} from '../../reports/report-types';

import {AnalyticsStatusButton} from '../analytics/report/analytics-status/analytics-status-button';

import {requestMcfxCompaniesSchema} from './companies-list/companies-actions';
import {VisitorsListPage} from './visitors-list-page';
import {getTab} from './visitors-page-wrapper';
import type {VisitorsPageTab} from './visitors-page-wrapper';
import {VisitorsSettingsPage} from './visitors-settings-page';

type Props = ContextRouter & {
    activeFilters: FilterObject[];
    onParamChange: (arg1: any, arg2: boolean) => any;
    onParamPush: (arg1: any, arg2: boolean) => any;
    urlParams: ReportURLParams<'visitors'>;
    onRemoveAllFilters: () => void;
    getPathForTab: (tab: VisitorsPageTab) => string;
    activeTab: VisitorsPageTab;
    onChangeTab: (newTab: VisitorsPageTab) => void;
};

export function VisitorsPage(props: Props) {
    const {getPathForTab, activeTab, onChangeTab} = props;
    const dispatch = useDispatch();
    const {onOpen: onOpenInfoModal} = useOpenableModal(OpenableModals.VISITOR_IQ_ONBOARDING_MODAL);

    // Fetch the mcfxCompanies schema for use on summary and list pages
    React.useEffect(() => {
        dispatch(requestMcfxCompaniesSchema());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const tabOptions = [
        {
            id: 'list',
            label: 'Visitors',
            icon: CompanyContactIcon,
            href: getPathForTab('list'),
            component: (
                <VisitorsListPage
                    activeFilters={props.activeFilters}
                    onParamChange={props.onParamChange}
                    // @ts-expect-error
                    onParamPush={props.onParamPush}
                    urlParams={props.urlParams}
                    onRemoveAllFilters={props.onRemoveAllFilters}
                />
            ),
        },
        {
            id: 'settings',
            label: 'Settings',
            icon: CogIcon,
            href: getPathForTab('settings'),
            component: <VisitorsSettingsPage />,
        },
    ];

    return (
        <PageContainer
            title='VisitorIQ'
            noPadding={activeTab === 'list'}
            pageTitleBar={
                <PageTitleBar
                    title='VisitorIQ'
                    subheaderPrimaryText={
                        <div className='flex'>
                            Identify potential customers and opportunities visiting your website
                            {/* @ts-expect-error */}
                            <HelpButton onClick={onOpenInfoModal} />
                        </div>
                    }
                    buttons={<AnalyticsStatusButton pageType='visitors' includeSeeAll={true} />}
                />
            }
            controlBar={
                <PageControlBar
                    tabs={{
                        selectedTab: activeTab,
                        options: tabOptions,
                        onChangeTab: (newTab) => {
                            onChangeTab(getTab(newTab));
                        },
                    }}
                />
            }
        >
            {/* @ts-expect-error */}
            <TabbedContent selectedTab={activeTab} tabOptions={tabOptions} />
        </PageContainer>
    );
}
